import React from "react";
import Svg, { Path } from "react-native-svg";

const LocationPin = ({ fill = "#E40046" }) => (
  <Svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      d="M11.9989 19.6799C17.0357 19.6799 21.1189 15.5968 21.1189 10.5599C21.1189 5.5231 17.0357 1.43994 11.9989 1.43994C6.96207 1.43994 2.87891 5.5231 2.87891 10.5599C2.87891 15.5968 6.96207 19.6799 11.9989 19.6799Z"
      fill="white"
    />
    <Path
      d="M12.0153 16.3539C15.2058 16.3539 17.7923 13.7675 17.7923 10.5769C17.7923 7.38637 15.2058 4.79993 12.0153 4.79993C8.82473 4.79993 6.23828 7.38637 6.23828 10.5769C6.23828 13.7675 8.82473 16.3539 12.0153 16.3539Z"
      fill="#E40046"
    />
    <Path
      d="M18.7867 3.7717C16.9735 1.95853 14.5627 0.959961 11.9984 0.959961C9.43418 0.959961 7.02339 1.95853 5.21022 3.7717C3.39701 5.58495 2.39844 7.9957 2.39844 10.56C2.39844 15.0838 5.56109 18.9894 9.9547 19.9412L11.9984 22.6662L14.0422 19.9411C18.4358 18.9894 21.5984 15.0838 21.5984 10.56C21.5984 7.9957 20.5999 5.58495 18.7867 3.7717ZM11.9984 3.46616C15.8866 3.46616 19.0498 6.6294 19.0498 10.5175C19.0498 14.4056 15.8866 17.5688 11.9984 17.5688C8.11031 17.5688 4.94711 14.4056 4.94711 10.5175C4.94711 6.6294 8.11031 3.46616 11.9984 3.46616Z"
      fill="#222222"
    />
  </Svg>
);

export default LocationPin;
